import { EvtHeader } from "components/header";
import React from "react";
import ToolForm from "../form";

const CreateTool = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Tool" />
      <div className="p-6 max-w-2xl">
        <ToolForm />
      </div>
    </div>
  );
};

export default CreateTool;
